// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-container {
  font-family: Arial, sans-serif;
  margin: auto;
}
.address-items-container {
  max-height: 620px;
  overflow: auto;
  margin-bottom: 30px;
}

.address-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #fff;
  /* min-width: 495px; */
  max-width: 539px;
}

.address-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
}

.address-header .icon {
  margin-right: 10px;
  height: 48px;
  width: 48px;
  display: flex;
  background: #f8f9fa;
  justify-content: center;
  border-radius: 29px;
  align-items: center;
  border: 2px solid #ffffff;
  box-shadow: 0px 4px 4px 0px #373d430d;
}

.address-details input[type="text"],
.address-details textarea {
  display: block;
  width: calc(100% - 20px);
  margin: 8px 0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.address-details textarea {
  height: 60px;
}

.address-info {
  color: #333;
}

.save-btn {
  background-color: #b22222;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 4px;
  width: 50%;
  cursor: pointer;
  font-size: 16px;
}

.save-cancel-btn {
  border: 1px solid rgba(55, 61, 67, 0.67);
  background-color: white;
  color: rgba(55, 61, 67, 0.47);
  padding: 10px;
  border-radius: 4px;
  width: 20%;
  cursor: pointer;
  font-size: 16px;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-address-btn,
.continue-btn {
  background-color: #ff4500;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.add-address-btn {
  background-color: #00a2ff;
}

.address-input {
  margin-right: 6px;
}

.phone-address {
  display: flex;
  justify-content: space-between;
}

.phone-address input {
  max-width: 245px !important;
}

.address-details input {
  background: #dae0e733;
  height: 30px;
}

.address-details textarea {
  background: #dae0e733;
}

a.blueLink {
  display: flex;
  font-family: Nunito;
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;
  text-align: left;
  color: #4793ef;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}

.blueLink img {
  margin-right: 5px;
}

.blueLink.buzz {
  color: #0d6efd;
  font-weight: 900;
  text-decoration: underline;
  animation: buzz-cycle 4s infinite;
}

@keyframes buzz-cycle {
  0% { transform: none; }
  1% { transform: translateX(0); }
  2% { transform: translateX(-1px) rotate(-0.5deg); }
  3% { transform: translateX(1px) rotate(0.5deg); }
  4% { transform: translateX(-1px) rotate(-0.5deg); }
  5% { transform: none; }
  100% { transform: none; }
}

.addressName {
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
}

.addressName span {
  color: #373d43;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.82px;
  text-align: left;
}

.addressName span {
  font-size: 16px;
  font-weight: 800;
  line-height: 21.82px;
  text-align: left;
}

.address-item label {
  display: flex;
}

.address-item.form label {
  display: block;
}

.address-header input {
  color: #4793ef;
}

.zip-match-indicator {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 8px 0;
  display: flex;
  align-items: center;
}

.zip-match-indicator.match {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.zip-match-indicator.no-match {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.zip-highlight-error {
  color: #dc3545 !important;
  font-weight: bold;
  text-decoration: underline;
}

@media (max-width: 930px) {
  .address-item {
    width: calc(100% - 34px);
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AddressFrom/styles.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,KAAK,eAAe,EAAE;EACtB,KAAK,wBAAwB,EAAE;EAC/B,KAAK,2CAA2C,EAAE;EAClD,KAAK,yCAAyC,EAAE;EAChD,KAAK,2CAA2C,EAAE;EAClD,KAAK,eAAe,EAAE;EACtB,OAAO,eAAe,EAAE;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF","sourcesContent":[".address-container {\n  font-family: Arial, sans-serif;\n  margin: auto;\n}\n.address-items-container {\n  max-height: 620px;\n  overflow: auto;\n  margin-bottom: 30px;\n}\n\n.address-item {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n  background-color: #fff;\n  /* min-width: 495px; */\n  max-width: 539px;\n}\n\n.address-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 8px;\n}\n\n.address-header .icon {\n  margin-right: 10px;\n  height: 48px;\n  width: 48px;\n  display: flex;\n  background: #f8f9fa;\n  justify-content: center;\n  border-radius: 29px;\n  align-items: center;\n  border: 2px solid #ffffff;\n  box-shadow: 0px 4px 4px 0px #373d430d;\n}\n\n.address-details input[type=\"text\"],\n.address-details textarea {\n  display: block;\n  width: calc(100% - 20px);\n  margin: 8px 0;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.address-details textarea {\n  height: 60px;\n}\n\n.address-info {\n  color: #333;\n}\n\n.save-btn {\n  background-color: #b22222;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  width: 50%;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.save-cancel-btn {\n  border: 1px solid rgba(55, 61, 67, 0.67);\n  background-color: white;\n  color: rgba(55, 61, 67, 0.47);\n  padding: 10px;\n  border-radius: 4px;\n  width: 20%;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.add-address-btn,\n.continue-btn {\n  background-color: #ff4500;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.add-address-btn {\n  background-color: #00a2ff;\n}\n\n.address-input {\n  margin-right: 6px;\n}\n\n.phone-address {\n  display: flex;\n  justify-content: space-between;\n}\n\n.phone-address input {\n  max-width: 245px !important;\n}\n\n.address-details input {\n  background: #dae0e733;\n  height: 30px;\n}\n\n.address-details textarea {\n  background: #dae0e733;\n}\n\na.blueLink {\n  display: flex;\n  font-family: Nunito;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 16px;\n  text-align: left;\n  color: #4793ef;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n}\n\n.blueLink img {\n  margin-right: 5px;\n}\n\n.blueLink.buzz {\n  color: #0d6efd;\n  font-weight: 900;\n  text-decoration: underline;\n  animation: buzz-cycle 4s infinite;\n}\n\n@keyframes buzz-cycle {\n  0% { transform: none; }\n  1% { transform: translateX(0); }\n  2% { transform: translateX(-1px) rotate(-0.5deg); }\n  3% { transform: translateX(1px) rotate(0.5deg); }\n  4% { transform: translateX(-1px) rotate(-0.5deg); }\n  5% { transform: none; }\n  100% { transform: none; }\n}\n\n.addressName {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  flex-direction: column;\n}\n\n.addressName span {\n  color: #373d43;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 21.82px;\n  text-align: left;\n}\n\n.addressName span {\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 21.82px;\n  text-align: left;\n}\n\n.address-item label {\n  display: flex;\n}\n\n.address-item.form label {\n  display: block;\n}\n\n.address-header input {\n  color: #4793ef;\n}\n\n.zip-match-indicator {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 8px 0;\n  display: flex;\n  align-items: center;\n}\n\n.zip-match-indicator.match {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.zip-match-indicator.no-match {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.zip-highlight-error {\n  color: #dc3545 !important;\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n@media (max-width: 930px) {\n  .address-item {\n    width: calc(100% - 34px);\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
